<template>
    <vx-box-glass class="text-slate-700 font-sans">
        <vx-wallpaper :icon="faNotebook"></vx-wallpaper>
        <div class="relative p-6 xl:p-10 max-w-2xl">
            <h2 class="mb-2 text-xl font-bold">
                Overview
                <font-awesome-icon widthAuto :icon="faTelescope"></font-awesome-icon>
            </h2>
            <p class="text-sm mb-3 font-sans text-slate-700 lg:text-base">
                Automations are powerful workflows you can use to super-charge your communication abilities. Use automations to do everything from remove contacts from campaigns if they reply, add them to new campaigns if they replied with specific phrases, to even update their contact profiles with new tags or custom attributes.
            </p>
            <a href="https://explore.voxie.com/voxiesupport/hc/en-us/articles/automations"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm font-sans font-normal text-sky-500 underline lg:text-base">
                See Docs for More
                <font-awesome-icon widthAuto class="ml-2"
                    :icon="faArrowRightLong"></font-awesome-icon>
            </a>
        </div>
    </vx-box-glass>
</template>

<script setup>
import { VxBoxGlass, VxWallpaper } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';
import { faTelescope, faNotebook } from '@fortawesome/pro-regular-svg-icons';
</script>
